import React, { useState } from "react";
import { Theme } from "../../../../providers/ThemeProvider";

const ServiceListItem = ({
  service,
  isSelected,
  onClick,
  theme,
}: {
  service: any;
  isSelected: boolean;
  onClick: () => void;
  theme: Theme;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={styles.serviceListItem(theme, isSelected, isHovered)}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {service.name}
    </div>
  );
};

const styles = {
  serviceListItem: (theme: any, selected: boolean, hovered: boolean) => ({
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${
      selected
        ? theme.colors_ds.PRIMARY_TEXT_MAIN
        : hovered
        ? theme.colors_ds.NEUTRAL_BORDER_DEFAULT
        : theme.colors_ds.NEUTRAL_BORDER_WEAK
    }`,
    boxShadow: selected ? "var(--box-shadow-general)" : "none",
    color: selected
      ? theme.colors_ds.PRIMARY_TEXT_MAIN
      : theme.colors_ds.NEUTRAL_TEXT_STRONG,
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    cursor: "pointer",
  }),
};

export default ServiceListItem;